// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "CircularTextGridModule-module--arrow-up-and-down--93831";
export var container = "CircularTextGridModule-module--container--1cea8";
export var contentContainer = "CircularTextGridModule-module--contentContainer--555fb";
export var desktopContentContainer = "CircularTextGridModule-module--desktopContentContainer--aaa1c";
export var divider = "CircularTextGridModule-module--divider--c1ff1";
export var divider1 = "CircularTextGridModule-module--divider1--37ec8";
export var divider2 = "CircularTextGridModule-module--divider2--80c75";
export var divider3 = "CircularTextGridModule-module--divider3--cf741";
export var divider4 = "CircularTextGridModule-module--divider4--bea1f";
export var divider5 = "CircularTextGridModule-module--divider5--02e04";
export var divider6 = "CircularTextGridModule-module--divider6--e1533";
export var dividerLine = "CircularTextGridModule-module--dividerLine--e18ff";
export var dot = "CircularTextGridModule-module--dot--d8e20";
export var dotContainer = "CircularTextGridModule-module--dotContainer--f318b";
export var horizontalLine = "CircularTextGridModule-module--horizontalLine--f5b7e";
export var icon = "CircularTextGridModule-module--icon--73522";
export var imageContainer = "CircularTextGridModule-module--imageContainer--1598f";
export var imageWrapper = "CircularTextGridModule-module--imageWrapper--c52cb";
export var item1 = "CircularTextGridModule-module--item1--179b6";
export var item2 = "CircularTextGridModule-module--item2--3551a";
export var item3 = "CircularTextGridModule-module--item3--baf94";
export var item4 = "CircularTextGridModule-module--item4--939a6";
export var item5 = "CircularTextGridModule-module--item5--dae19";
export var item6 = "CircularTextGridModule-module--item6--f31e3";
export var lastItem = "CircularTextGridModule-module--lastItem--ddc82";
export var lineAndDotContainer = "CircularTextGridModule-module--lineAndDotContainer--07f0a";
export var mainImage = "CircularTextGridModule-module--mainImage--76bb0";
export var mobileContentContainer = "CircularTextGridModule-module--mobileContentContainer--9ab56";
export var noIcon = "CircularTextGridModule-module--noIcon--47bd5";
export var textContainer = "CircularTextGridModule-module--textContainer--bc573";
export var textGridContainer = "CircularTextGridModule-module--textGridContainer--6a2b7";
export var textItemContainer = "CircularTextGridModule-module--textItemContainer--c69ca";
export var textItemIconContainer = "CircularTextGridModule-module--textItemIconContainer--a512f";
export var textItemTitle = "CircularTextGridModule-module--textItemTitle--c0e9f";
export var verticalLine = "CircularTextGridModule-module--verticalLine--fc6ee";
export var with3Items = "CircularTextGridModule-module--with3Items--5e9b7";
export var with4Items = "CircularTextGridModule-module--with4Items--0701e";
export var with5Items = "CircularTextGridModule-module--with5Items--25688";
export var with6Items = "CircularTextGridModule-module--with6Items--503cc";